import Vue from 'vue';
import VueMeta from 'vue-meta';
import {App, plugin} from '@inertiajs/inertia-vue';
import {InertiaProgress} from '@inertiajs/progress';
import {InertiaForm} from 'laravel-jetstream';
import PortalVue from 'portal-vue';
import VueI18n from 'vue-i18n';
import messages from '../Shared/translations';
import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faBan,
    faCheckCircle,
    faDiceD6,
    faGlobeAmericas,
    faHome,
    faMoneyCheck,
    faPowerOff,
    faSearch,
    faSignal,
    faTimesCircle,
    faTrashAlt,
    faUser,
    faUsers,
    faWallet,
    faTimes,
    faPlayCircle,
    faSpinner,
    faChevronCircleLeft,
    faChevronCircleRight,
    faExpand,
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {currency} from '../Shared/filters/currency';
import {formatDate, formatDateTime} from '../Shared/filters/datetime';
import VueMask from 'v-mask';

import Layout from './Layout';
import GuestLayout from '../terminal/GuestLayout';
import {ClickOutside} from "./directives/click-outside";
import bugsnagInit from '../Shared/bugsnag';
import Geolocation from '../Shared/geolocation';
import pusherInit from '../Shared/pusher';
import credLoad from '../Shared/credmanager';

credLoad.then(credMgr => {
window.credManager = credMgr

pusherInit();
if (process.env.MIX_APP_ENV === 'production') {
    bugsnagInit();
}

library.add(
    faPowerOff,
    faWallet,
    faDiceD6,
    faMoneyCheck,
    faBan,
    faSearch,
    faTrashAlt,
    faCheckCircle,
    faTimesCircle,
    faUser,
    faUsers,
    faGlobeAmericas,
    faHome,
    faSignal,
    faTimes,
    faPlayCircle,
    faSpinner,
    faChevronCircleLeft,
    faChevronCircleRight,
    faExpand
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.mixin({
    methods: {
        route,
        isRoute(...routes) {
            return routes.some(route => this.route().current(route));
        }
    }
});
Vue.use(plugin);
Vue.use(InertiaForm);
Vue.use(VueMask);
Vue.use(PortalVue);
Vue.use(VueI18n);
Vue.use(VueMeta);
if (!window.currency) {
    console.error('There is no currency set in global scope `window.currency`');
}
Vue.filter('currency', currency(window.currency));
Vue.filter('date', formatDate);
Vue.filter('datetime', formatDateTime);

Vue.directive('click-outside', ClickOutside);

InertiaProgress.init();

const i18n = new VueI18n({
    locale: navigator.language.split('-')[0],
    fallbackLocale: 'en',
    messages,
});

axios.defaults.withCredentials = true;

const casino = document.getElementById('app');
const geoTrackedPages = ["Play", "TerminalPlay"];
const geoCheckInterval = parseInt(window.geodataCheckInterval) > 0 ? parseInt(window.geodataCheckInterval) * 1000 : 0;
const geoSignificantDistanceToTrack = parseInt(window.geodataSignificantDistanceToTrack) > 0 ? parseInt(window.geodataSignificantDistanceToTrack) : 0;

new Vue({
    i18n,
    metaInfo: {
        title: '',
        titleTemplate: (title) => title ? `${title} - ${window.appName}` : window.appName
    },
    data() {
        return {
            currentComponent: JSON.parse(casino.dataset.page).component
        };
    },
    render: (h) =>
        h(App, {
            props: {
                initialPage: JSON.parse(casino.dataset.page),
                resolveComponent: (name) => {
                    const page = require(`./Pages/${name}`).default;
                    page.layout = page.layout === undefined ? Layout : page.layout;

                    if (name === 'Play' || name === 'CasinoLogin' || name === 'CasinoLoginRestriction') {
                        page.layout = GuestLayout;
                    }

                    return page;
                }
            }
        }),
    watch: {
        currentComponent: {
            immediate: true,
            handler(component) {
                if (geoTrackedPages.includes(component)) {
                    if (geoCheckInterval > 0) {
                        Geolocation.startGeolocationWatchTracking({
                            watchBufferInterval: geoCheckInterval,
                            significantDistanceToTrack: geoSignificantDistanceToTrack
                        });
                    }
                } else {
                    Geolocation.stopGeolocationWatchTracking();
                }
            }
        }
    }
}).$mount(casino);

});
